module.exports = __webpack_public_path__ + "img/twwky1.3d160d96.jpg";